module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//17.jpg?51c6e0defc44af2cc0e70b000a57e80c";